package com.parmartechnologies.business.feature.businessType.network

import com.parmartechnologies.core.feature.businessType.event.BusinessTypeEvent
import com.parmartechnologies.core.feature.businessType.network.BusinessTypeRequest
import com.parmartechnologies.core.feature.businessType.network.BusinessTypeResponse
import io.ktor.client.request.post
import io.ktor.client.statement.bodyAsText
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch
import kotlinx.serialization.json.Json
import com.parmartechnologies.core.network.rest.FriendlyClient
import com.parmartechnologies.core.constant.AppServer

class BusinessTypeNetwork {
    private val decoder = Json {
        ignoreUnknownKeys = true
        encodeDefaults = true
        isLenient = true
    }
    fun retrieve(
        request: BusinessTypeRequest,
        onResult: (BusinessTypeResponse?, String?) -> Unit
    ) {
        CoroutineScope(Job() + Dispatchers.Default).launch {
            val apiRoute = AppServer.shared().getRestApiEndPointFor(BusinessTypeEvent.api,BusinessTypeEvent.RETRIEVE)
            try {
                val response = FriendlyClient.post(apiRoute)
                val responseBody = response.bodyAsText()
                val responseData : BusinessTypeResponse = decoder.decodeFromString(responseBody)
                onResult(responseData,response.bodyAsText())
            } catch (t: Throwable) {
                onResult(null,t.message)
                print(t)
            }
        }
    }
}